import { Button, ButtonProps, styled } from '@mui/material';

/**
 * A styled Button component that is used in a ButtonGroup - it has a border when selected to appear same size as outlined buttons.
 */

const ButtonGroupOption = styled(Button)<ButtonProps & { selected: boolean }>(
    ({ color, selected, theme: { palette } }) => ({
        border: selected ? `1px solid ${color || palette.primary.main} !important` : undefined,
    }),
);

export default ButtonGroupOption;
